import {useCallback} from "react";
import {
	SelectField,
	InputField
} from "~/components/Forms";
import {
	useCan
} from "~/hooks";

function UploadWebsiteSearchBar({filter, onSearchChange, onChange}) {

	const can = {
		listAll: useCan('ListAll'),
		listGroup: useCan('ListGroup'),
	};

	const typeOptions = [
		{value: '', label: 'Tất cả loại upload'},
		{value: 1, label: 'Upload website bàn giao'},
		{value: 2, label: 'Chạy trước trả tiền sau'},
		{value: 4, label: 'Chưa thanh toán xong'},
		{value: 3, label: 'Hỗ trợ khách hàng'}
	];

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	const handleTypeChange = useCallback((value) => {
		if(onChange) onChange('type', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField defaultValue={filter.keyword} placeholder="Tên miền" onChange={handleKeywordChange} />
					<SelectField placeholder="Loại" options={typeOptions} onChange={handleTypeChange}/>
				</form>
			</div>
		</div>
	)
}

export default UploadWebsiteSearchBar;